import { styled, component, spin } from '../../utils/style';
import { Format, StyleColor } from '../../utils/styles-constants';
import { Button } from '../../components/Button/styles';

const containerWidth = '625px';
const containerWidthResponsive = '290px';

export const Content = styled()(component.div, 'Content') `
	background: ${StyleColor.White};
	font-size: 14px;
	position: absolute;
	top: 44px;
	left: 0;
	right: 0;
	bottom: 0;
	overflow: auto;
`;

export const GalleryCover = styled()(component.div, 'GalleryCover') `
	background: ${StyleColor.LightBlue};
	border-bottom: 1px solid ${StyleColor.Grey100};
	height: 200px;

	@media ${Format.Smartphone} {
		height: 120px;
	}
`;

export const GalleryCoverContainer = styled()(component.div, 'GalleryCoverContainer') `
	height: 100%;
	display: flex;
	align-items: center;
	margin-left: 100px;

	@media ${Format.Smartphone} {
		margin-left: 20px;
	}
`;

interface GalleryCoverImgProps {
	imageUrl?: string;
}
export const GalleryCoverImg = styled<GalleryCoverImgProps>()(component.div, 'GalleryCoverImg') `
	border-radius: 25px;
	height: 150px;
	width: 150px;
	box-shadow: 0px 0px 8px 0px ${StyleColor.Grey600};
	background-color: ${StyleColor.Blue};
	${ p => p.imageUrl ? `background-image: url('${p.imageUrl}');` : ''}
	flex-shrink: 0;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;

	@media ${Format.Smartphone} {
		width: 90px;
		height: 90px;
	}
`;

export const GalleryCoverName = styled()(component.div, 'GalleryCoverName') `
	display: flex;
	font-size: 24px;
	margin-left: 40px;
	margin-right: 20px;
	color: ${props => props.theme.primary.contentColor};

	@media ${Format.Smartphone} {
		overflow: hidden;
		word-wrap: break-word;
		word-break: break-all;
		margin-left: 20px;
		font-size: 20px;
	}
`;

export const AppInfosContainer = styled()(component.div, 'AppInfosContainer') `
	border-bottom: 1px solid ${StyleColor.Grey100};
	padding-bottom: 25px;
`;

export const AppInfos = styled()(component.div, 'AppInfos') `
	margin-left: auto;
	margin-right: auto;
	width: ${containerWidth};

	@media ${Format.Smartphone} {
		width:${containerWidthResponsive};
	}
`;

export const ButtonContainer = styled()(component.div, 'ButtonContainer') `
	display: flex;
	flex-direction: row;
	justify-content: space-around;

	@media ${Format.Smartphone} {
		flex-direction: column;
	}
`;

export const ParametersPageButton = Button.extend`
	margin-top: 25px;
	width: 210px;
	color: ${StyleColor.White};

	@media ${Format.Smartphone} {
		width: 250px;
		align-self: center;
	}
`;

export const CancelButton = ParametersPageButton.extend`
	background-color: ${StyleColor.Grey500};
	border-color: ${StyleColor.Grey500};

	& > span {
		width: 50%;
	}

	& > svg {
		height: 25px;
		width: 25px;
		animation: ${spin} 2s linear infinite;
	}
`;

export const GalleryDescriptionContainer = styled()(component.div, 'GalleryDescriptionContainer') `
	margin-left: auto;
	margin-right: auto;
	width: ${containerWidth};

	@media ${Format.Smartphone} {
		width: ${containerWidthResponsive};
	}
`;

export const GalleryDescriptionTitle = styled()(component.div, 'GalleryDescriptionTitle') `
	color: ${StyleColor.Black};
	font-weight: 500;
	margin: 30px 0;
`;

export const GalleryDescriptionContent = styled()(component.div, 'GalleryDescriptionContent') `
	margin-bottom: 50px;
`;

export const GalleryDescriptionContentLine = styled()(component.div, 'GalleryDescriptionContentLine') `
	min-height: 13px;
	font-size: 13px;
	color: ${StyleColor.Grey400};
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/styles.ts